<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row align="center">
        <v-col class="text-right" >
          <v-btn @click="$router.push({ name: 'branch-create'})">Создать филиал</v-btn>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет филиалов"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="branches"
              v-model="selected"
              :search="search"
              :options.sync="options"
              :item-class="getItemClass"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :footer-props="footerProps"
              :fixed-header="true"
              height="60vh"
              :loading="loading"
              loading-text="Загрузка филиалов... Подождите пожалуйста"
      >
        <template v-slot:item.delivery_time="{ item }">
          <v-chip
                  class="mr-2 time-chip"
                  label
          >
            {{ item.delivery_time }}
            <v-icon right small dark @click="resetTime(item)">
              mdi-close-circle
            </v-icon>
          </v-chip>
          <span @click="changeTime(item, -5)" class="plus-minus-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
              <circle cx="12" cy="12" r="11.5" fill="white" stroke="#EAF0F6"/>
              <rect x="17" y="11" width="2" height="10" transform="rotate(90 17 11)" fill="#B4BDC6"/>
            </svg>
          </span>
          <span @click="changeTime(item, 5)" class="plus-minus-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="11.5" fill="white" stroke="#EAF0F6"/>
              <rect x="11.166" y="7" width="2" height="10" fill="#B4BDC6"/>
              <rect x="17" y="11.166" width="2" height="10" transform="rotate(90 17 11.166)" fill="#B4BDC6"/>
            </svg>
          </span>
        </template>
        <template v-slot:item.is_self_delivery="{ item }">
          <v-simple-checkbox v-model="item.is_self_delivery" disabled></v-simple-checkbox>
        </template>
        <template v-slot:item.terminal_id="{ item }">
          <v-select
              :items="terminals"
              :item-text="terminal => terminal.name"
              :item-value="terminal => terminal.id"
              v-model="item.terminal_id"
              hide-details
              dense
              outlined
              @change="changeTerminal(item)"
          ></v-select>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="$router.push({ name: 'branch-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import BranchService from '../../../api/BranchService'
    import ModifierService from "../../../api/ModifierService";
    import AreaService from "../../../api/AreaService";

    export default {
        name: 'ProductIndex',
        components: {},
        data: () => ({
            overlay: false,
            search: '',
            loadingModal: false,
            loading: true,
            tab: null,
            dialog: false,
            selected: [],
            submitDialog: false,
            submitItem: null,
            branches: [],
            terminals: [],
            options: {},
            branch: {
                id: null,
                name: '',
                name_ua: '',
            },
            footerProps: {
                itemsPerPageText: 'Тегов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [-1]
            },
            totalProducts: 0,
            headers: [
                {
                    text: 'Филиал',
                    value: 'name',
                  sortable: false,
                },
              {
                text: 'Самовывоз',
                value: 'is_self_delivery',
                sortable: false,
              },
              {
                text: 'Терминал',
                value: 'terminal_id',
                width: '400px',
                sortable: false,
              },
                {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
            ],
        }),
        mounted() {
          BranchService.terminalGroups().then(response => {
            this.terminals = response.data
          })
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
          submitDelete(item = null){
            if(item){
              this.removeBranch(item)
            } else {
              //this.massDelete()
            }
          },
          resetTime(item){
            BranchService.update({
              id: item.id,
              delivery_time: item.default_delivery_time
            }).then(response => {
              item.delivery_time = response.data.delivery_time
            })
          },
            changeTime(item, time){
              BranchService.update({
                id: item.id,
                change_time: time
              }).then(response => {
                  item.delivery_time = response.data.delivery_time
              })
            },
            getItemClass(item){
              if(item.delivery_time != item.default_delivery_time){
                return 'changed-row'
              }
            },
            changeBranch(item){
              BranchService.update({
                id: item.id,
                branch_id: item.branch
              })
            },
            changeTerminal(item){
              BranchService.update({
                id: item.id,
                terminal_id: item.terminal_id
              })
            },
            removeBranch(item){
              BranchService.remove(item.id).then(response => {
                  this.loading = true
                  this.getDataFromApi()
              })
            },
            createBranch(){
                this.loadingModal = true;
                BranchService.create(this.branch).then(response => {
                    this.getDataFromApi();
                    this.loadingModal = false;
                })
            },
            updateBranch(){
                this.loadingModal = true;
                BranchService.update(this.branch).then(response => {
                    this.getDataFromApi();
                    this.loadingModal = false;
                })
            },
            getDataFromApi() {
                this.loading = true

                BranchService.list({})
                    .then(response => {
                        this.branches = response.data
                        this.loading = false
                    })
            },
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
